// extracted by mini-css-extract-plugin
export default {"w-full":"Comments_w-full__8ILDs","head":"Comments_head__Zn4ac","form":"Comments_form__v9DpI","title":"Comments_title__KhuXC"};